import React from 'react';
import Link, { navigateTo } from 'gatsby-link';

const HeaderLink = ({ to, label, onClick }) => {
    const internal = /^\/(?!\/)/.test(to);

    if (internal) {
        return (
            <Link onClick={onClick} className="HeaderLink" to={to}>
                {label}
            </Link>
        );
    }

    return (
        <a className="HeaderLink" href={to} target="_blank">
            {label}
        </a>
    );
};

export default HeaderLink;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLink.js